import { render, staticRenderFns } from "./Metal.vue?vue&type=template&id=5b07fb4e&scoped=true&"
import script from "./Metal.vue?vue&type=script&lang=js&"
export * from "./Metal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b07fb4e",
  null
  
)

export default component.exports